import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import SingleUser from './pages/SingleUser';
import Reports from './pages/Reports';
import Messages from './pages/Messages';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Students from './pages/Students';
import EnterScores from './pages/EnterScores';
import StudentSingleResult from './pages/StudentSingleResult';
import EnterClassResult from './pages/EnterClassResult';
import AdminDashboard from './pages/AdminDashboard';
import Teachers from './pages/Teachers';
import AddTeacher from './pages/AddTeacher';
import EditTeacher from './pages/EditTeacher';
import Classes from './pages/Classes';
import AddClass from './pages/AddClass';
import AddStudent from './pages/AddStudent';
import EditStudent from './pages/EditStudent';
import EditClass from './pages/EditClass';
import AllStudents from './pages/AllStudents';
import { generateFCMToken, messaging } from './firebaseConfig';
import { onMessage } from 'firebase/messaging';
import Message from './components/Message';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import notificationSound from './assets/notification.mp3';
import ResultCodes from './pages/ResultCodes';
import Profile from './pages/Profile';
import GeneratePerformance from './pages/GeneratePerformance';
import StudentsPerformance from './pages/StudentsPerformance';

// Protected route component that checks Redux auth state
const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  
  // Check if user is logged in and has a valid token
  const token = localStorage.getItem('authToken');
  
  if (!isLoggedIn || !token || !user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Public route component (for login page)
const PublicRoute = ({ children }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const token = localStorage.getItem('authToken');
  
  // If user is already logged in, redirect to dashboard
  if (isLoggedIn && token && user) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  // Notification.requestPermission().then(() => {
  //   new Notification("Test", { body: "Does this show up?" });
  // });
  // onMessage(messaging, (payload) => {
  //   console.log("Foreground message received: ", payload);
  //   // Play sound
  //   // const audio = new Audio('/notification.mp3'); // Place notification.mp3 in public/
  //   const audio = new Audio(notificationSound);
  //   audio.play();

  //   // Show toast notification
  //   toast(<Message notification={payload.notification} />, {
  //     position: "top-right", // or "bottom-left", "top-center", etc.
  //     autoClose: 20000, // duration in ms
  //     closeOnClick: true,
  //     onClick: () => {
  //       // Your custom click handler
  //       console.log("Toast clicked!");
  //     },
  //     pauseOnHover: true,
  //     draggable: true,
  //   });
  // });
  
  // async function requestPermission() {
  //   //requesting permission using Notification API
  //   const permission = await Notification.requestPermission();
  //   console.log(`Notification permission: ${permission}`);
    

  //   if (permission === "granted") {
  //     const token = await generateFCMToken();

  //     //We can send token to server
  //     // console.log("Token generated : ", token);
  //   } else if (permission === "denied") {
  //     //notifications are blocked
  //     alert("You denied for the notification");
  //   }
  // }

  // useEffect(() => {
  //   requestPermission();
  // }, []);

  return (
    <>
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="add-student" element={<AddStudent />} />
          <Route path="students" element={<Students />} />
          <Route path="edit-student/:uuid" element={<EditStudent />} />
          <Route path="add-teacher" element={<AddTeacher />} />
          <Route path="teachers" element={<Teachers />} />
          <Route path="edit-teacher/:uuid" element={<EditTeacher />} />
          <Route path="add-class" element={<AddClass />} />
          <Route path="classes" element={<Classes />} />
          <Route path="edit-class/:uuid" element={<EditClass />} />
          <Route path="students/:id" element={<SingleUser />} />
          {/* <Route path="enter-scores/:studentUuid/:classUuid" element={<EnterScores />} /> */}
          <Route path="student-single-result" element={<StudentSingleResult />} />
          <Route path="results" element={<EnterClassResult />} />
          <Route path="classes" element={<Users />} />
          <Route path="all-students" element={<AllStudents />} />
          <Route path="generate-performance" element={<GeneratePerformance />} />
          <Route path="students-performance" element={<StudentsPerformance />} />
          <Route path="result-codes" element={<ResultCodes />} />
          <Route path="attendance" element={<Reports />} />
          <Route path="assignments" element={<Messages />} />
          <Route path="grades" element={<Reports />} />
          <Route path="reports" element={<Reports />} />
          <Route path="messages" element={<Messages />} />
          <Route path="settings" element={<Settings />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </Router>
    {/* <ToastContainer/> */}
    </>
  );
}

export default App;
